import { type MedicalPlanDisplayItem } from '../medicalPlanTypes'

const STORAGE_KEY = 'thatch-plan-comparison'

export const getStoredPlansForComparison = (): MedicalPlanDisplayItem[] => {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY)
    return stored ? JSON.parse(stored) : []
  } catch {
    return []
  }
}

export const storePlansForComparison = (plans: MedicalPlanDisplayItem[]) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(plans))
  } catch (error) {
    console.error('Failed to store plan comparison state:', error)
  }
}

export const clearPlansForComparison = () => {
  sessionStorage.removeItem(STORAGE_KEY)
}
